import "./App.css";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Top from "./components/Top";
import ScrollToTop from "./components/ScrollToTop";
import MobileMenu from "./components/MobileMenu";
import Header from "./components/Header/Header";
import Loader from "./components/Loader";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Service from "./pages/Service/Service";
import SeviceDetails from "./pages/Service/SeviceDetails";
import Project from "./pages/Project/Project";
import Gallery from "./pages/Gallery/Gallery";
import Blog from "./pages/Blog/Blog";
import BlogDetails from "./pages/Blog/BlogDetails";
import Contact from "./pages/Contact/Contact";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {isLoading ? (
        <Loader />
      ) : (
        <BrowserRouter>
          <Top />
          <ScrollToTop />
          <MobileMenu closeMenu={closeMenu} menuOpen={menuOpen} />
          <Header toggleMenu={toggleMenu} />

          <WhatsAppButton />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/service" element={<Service />} />
            <Route
              path="/service/service-details/:id"
              element={<SeviceDetails />}
            />
            <Route path="/project" element={<Project />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/blog-details/:id" element={<BlogDetails />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
